import React, { useState } from 'react';
import {
  Dialog, DialogActions, DialogContent, DialogTitle,
  TextField, Button, Switch, FormControlLabel
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { addDoc, collection } from 'firebase/firestore';
import { db } from '../Components/auth/firebaseConfig'; // Adjust the import path as necessary

function AddBoard() {
  // State to hold the new board data
  const [newBoard, setNewBoard] = useState({
    projectId: '',         // ID of the project associated with the board
    boardName: '',         // Name of the new board
    projectTitle: '',      // Title of the project
    boardDescription: '',   // Description of the board
    isPublic: true,        // Boolean to indicate if the board is public
  });

  // useNavigate hook for navigation
  const navigate = useNavigate();

  // Function to handle input changes in the form fields
  const handleChange = (e) => {
    const { name, value } = e.target; // Destructure name and value from the event target
    setNewBoard({ ...newBoard, [name]: value }); // Update the state with the new value
  };

  // Function to handle the switch toggle for public/private board
  const handleSwitchChange = (e) => {
    setNewBoard({ ...newBoard, isPublic: e.target.checked }); // Update isPublic state
  };

  // Function to handle form submission
  const handleSubmit = async () => {
    // Add the new board document to the Firestore collection
    await addDoc(collection(db, 'boards'), newBoard);
    // Navigate to the boards page after submission
    navigate('/boards');
  };

  return (
    <Dialog open={true} onClose={() => navigate('/boards')}>
      <DialogTitle>Add New Board</DialogTitle>
      <DialogContent>
        {/* Input field for Project ID */}
        <TextField
          autoFocus
          margin="dense"
          name="projectId"
          label="Project ID"
          fullWidth
          variant="outlined"
          value={newBoard.projectId}
          onChange={handleChange}
        />
        {/* Input field for Board Name */}
        <TextField
          margin="dense"
          name="boardName"
          label="Board Name"
          fullWidth
          variant="outlined"
          value={newBoard.boardName}
          onChange={handleChange}
        />
        {/* Input field for Project Title */}
        <TextField
          margin="dense"
          name="projectTitle"
          label="Project Title"
          fullWidth
          variant="outlined"
          value={newBoard.projectTitle}
          onChange={handleChange}
        />
        {/* Input field for Board Description */}
        <TextField
          margin="dense"
          name="boardDescription"
          label="Board Description"
          fullWidth
          variant="outlined"
          value={newBoard.boardDescription}
          onChange={handleChange}
        />
        {/* Switch to toggle between public/private board */}
        <FormControlLabel
          control={
            <Switch
              checked={newBoard.isPublic}
              onChange={handleSwitchChange}
              name="isPublic"
              color="primary"
            />
          }
          label="Is Public?"
        />
      </DialogContent>
      <DialogActions>
        {/* Cancel button to navigate back to boards page */}
        <Button onClick={() => navigate('/boards')} color="error">
          Cancel
        </Button>
        {/* Submit button to add the new board */}
        <Button onClick={handleSubmit} color="success">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddBoard;
